import dayjs from 'dayjs';

import { productStore, productStoreValues } from './productStore';
import { IProductStoreActions } from './types';

import { getFormattedProductExclusions } from '../components/ProductTabs/Exclusions/lib';

export const initProductSuccessAction: IProductStoreActions['initProductSuccessAction'] = (data) => {
  const {
    id,
    name,
    order,
    status,
    regions,
    productId,
    exclusions,
    sponsorCode,
    imageMetadataId,
    effectivePeriods,
    receiptAcceptanceDaysThreshold,
  } = data;

  const initialValues = {
    name,
    regions,
    productId,
    sponsorCode,
    imageMetadataId,
    receiptAcceptanceDaysThreshold,
    effectivePeriods: [...(effectivePeriods || [])].map(({ id: ID, effectiveFrom, effectiveTo }) => ({
      id: String(ID),
      effectiveFrom: dayjs(effectiveFrom),
      effectiveTo: dayjs(effectiveTo),
    })),
  };

  productStore.setState({
    id,
    order,
    imgId: imageMetadataId,
    status,
    exclusions: exclusions?.map(getFormattedProductExclusions),
    initialValues,
  });
};

export const initProductIdentitiesAction: IProductStoreActions['initProductIdentitiesAction'] = (identities) => {
  productStore.setState({ identities });
};

export const updateProductExclusion: IProductStoreActions['updateProductExclusionAction'] = (exclusions) => {
  productStore.setState({ exclusions });
};

export const resetProductAction: IProductStoreActions['resetProductAction'] = () => {
  productStore.setState(productStoreValues);
};
